import React, { Component } from "react";

class Slider extends Component {
  render() {
    const cards = [
      { id: 1, text: "Seda Residences Makati" },
      { id: 2, text: "Somerset" },
      { id: 3, text: "The Mini Suites" },
      { id: 4, text: "Ascott Makati" },
      { id: 5, text: "Dusit Thani Manila" },
      { id: 6, text: "Holiday Inn & Suites" },
      { id: 7, text: "Shangri-la" },
      { id: 8, text: "Seda Residences Makati" },
      { id: 9, text: "Somerset" },
      { id: 10, text: "The Mini Suites" },
      { id: 11, text: "Ascott Makati" },
      { id: 12, text: "Dusit Thani Manila" },
      { id: 13, text: "Holiday Inn & Suites" },
      { id: 14, text: "Shangri-la" },
    ];

    // Duplicate cards multiple times for infinite effect
    const infiniteCards = [...cards, ...cards, ...cards];

    const cardsOther = [
      { id: 1, text: "Anya Resort Tagaytay" },
      { id: 2, text: "Westin Hotels & Resorts" },
      { id: 3, text: "Grand Westside Hotel" },
      { id: 4, text: "Kingsford Hotel Manila" },
      { id: 5, text: "Sequoia Manila Bay" },
      { id: 6, text: "Belmont Hotels & Resorts" },
      { id: 7, text: "Marriot Hotels & Resorts" },
      { id: 8, text: "Anya Resort Tagaytay" },
      { id: 9, text: "Westin Hotels & Resorts" },
      { id: 10, text: "Grand Westside Hotel" },
      { id: 11, text: "Kingsford Hotel Manila" },
      { id: 12, text: "Sequoia Manila Bay" },
      { id: 13, text: "Belmont Hotels & Resorts" },
      { id: 14, text: "Marriot Hotels & Resorts" },
    ];

    // Duplicate cards multiple times for infinite effect
    const infiniteCardsOther = [...cardsOther, ...cardsOther, ...cardsOther];

    return (
      <div className="marquee-container z-3">
        {/* Top Marquee - Moves Right */}
        <div className="marquee marquee-right">
          <div className="marquee-content">
            {infiniteCards.map((card, index) => (
              <div className="marquee-card" key={index}>
                <span className="fw-bold">{card.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Marquee - Moves Left */}
        <div className="marquee marquee-left">
          <div className="marquee-content">
            {infiniteCardsOther.map((card, index) => (
              <div className="marquee-card" key={index}>
                <span className="fw-bold">{card.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Slider;
